import { p5InstanceExtensions, Shader, Graphics } from "p5";

class Background {
  private readonly p: p5InstanceExtensions;
  private readonly theShader: Shader;
  private theShaderTexture: Graphics | null;
  constructor(p: p5InstanceExtensions, shaders: Shader) {
    this.p = p;
    this.theShader = shaders;
    this.theShaderTexture = null;
  }

  setup = () => {
    this.p.shader(this.theShader);
    this.setUniformToFrag();
  };

  draw = () => {
    const width = this.p.width;
    const height = this.p.height;
    this.setUniformToFrag();
    this.p.shader(this.theShader);
    this.p.rect(-width, -height / 2, width, height);
  };

  setUniformToFrag = () => {
    this.theShader.setUniform("time", this.p.frameCount * 0.01);
    this.theShader.setUniform("resolution", [this.p.width, this.p.height]);
    this.theShader.setUniform("speed", 0.5);
  };
}

export default Background;
